import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { CashCollections } from 'src/features/cashCollections/types/cashCollections';
import type { ListDTO, ListResponse } from 'src/types';

const RESOURCE = '/cash-collection/cash-collection/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    date_after?: string;
    date_before?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponse<CashCollections>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useListCashCollections };
